export default __webpack_public_path__ + "static/media/7.45ee2ea8.png";